import React from 'react';

function HeartNotFill(props: object) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.1117 15.6077C9.84526 15.6977 9.40646 15.6977 9.14004 15.6077C6.86765 14.8652 1.79004 11.7677 1.79004 6.5177C1.79004 4.2002 3.74116 2.3252 6.14676 2.3252C7.57287 2.3252 8.83444 2.9852 9.62586 4.0052C10.4173 2.9852 11.6867 2.3252 13.105 2.3252C15.5106 2.3252 17.4617 4.2002 17.4617 6.5177C17.4617 11.7677 12.3841 14.8652 10.1117 15.6077Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HeartNotFill;
